// @ts-strict-ignore
import { Injectable } from '@angular/core';
import {
  LMBusyIndicatorService,
  LMErrorUtilService,
  LMLoggerService,
  LMModalDialogWrapperRef,
  LMModalWrapperService
} from '@services/index';
import { AppConstants, LMDialogButtonKey, LMGlobalUtilService, LMUniqueIdService } from '@app/utils';
import { LMAddTagDialogComponent } from '@app/components';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class LMAddTagDialogService {

  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService,
    private lmErrorUtilService: LMErrorUtilService,
    protected lmUniqueIdService: LMUniqueIdService,
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmModalWrapperService: LMModalWrapperService) {
  }

  private dialog: LMModalDialogWrapperRef<LMAddTagDialogComponent>;
  private component: LMAddTagDialogComponent;

  public openAddTagDialog(url: string, data: Array<LMListDataView>) {

    const attributes: SohoAttributesArray = [ { name:  'data-automation-id',  value: 'lm-add-tag-modal' } ];
    const options: SohoModalOptions = {
      attributes
    };

    this.dialog = this.lmModalWrapperService.modal(LMAddTagDialogComponent, options);
    return this.openDialog(url, data);
  }

  public getModalButtons(url: string, data: Array<LMListDataView>): SohoModalButton[] {
    const dialogId = 'AddTag';

    const buttons: SohoModalButton[] = [
      {
        id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CANCEL ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.CANCEL),
        click: (e, modal) => {
          this.dialog.close(<LMAddTagResponse>{
          });
        }
      },
      {
        id:    this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.OK ]),
        text:  Soho.Locale.translate(LMDialogButtonKey.OK),
        isDefault: true,
        click: (e, modal) => {
          if (this.component.onDialogSubmit()) {
            this.lmBusyIndicatorService.showBusyIndicator();
            const response = this.component.getResponse();
            this.createTag(url, response, data)
              .subscribe((result: LMAddTagResponse) => {
                if (result.status === AppConstants.STATUS_COMPLETED) {
                  const message = result.message || Soho.Locale.translate('ActionSuccessful');
                  this.lmGlobalUtilService.displayToastMessage('', message);
                } else {
                  this.lmErrorUtilService.handleError(result.message, null, result.status, null);
                }
                this.lmBusyIndicatorService.hideBusyIndicator();
              });
            this.dialog.close(response);
          }
        }
      }
    ];
    return buttons;
  }

  private openDialog(url: string, data: Array<LMListDataView>): LMModalDialogWrapperRef<LMAddTagDialogComponent> {
    this.component = this.dialog.componentDialog;

    return this.dialog.title(Soho.Locale.translate('SelectTags'))
      .buttons(this.getModalButtons(url, data))
      .open();
  }

  public createTag(url: string, request: any, dataViews: Array<LMDataView>): Observable<LMAddTagResponse> {

    const formRequest: LMAddTagFormRequest = {
      requestType: request.requestType,
      selectedTags: request.dynamicBusinessObjectTags,
      dataViews,
    };

    return this.makeFormRequest(url, formRequest);
  }

  private makeFormRequest(url: string, formRequest: LMAddTagFormRequest): Observable<LMAddTagResponse> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    return <Observable<LMAddTagResponse>>this.http.post(url, JSON.stringify(formRequest), { headers }).pipe(
      catchError(error => this._handleError(error)));
  }

  private _handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }
}

